export default class PopUpLink {
  constructor() {
    this.registerLinkCLick();
  }

  /**
   * Register click handlers
   */
  registerLinkCLick() {
    document.querySelectorAll('.open-in-interstitial').forEach((link) => {
      link.addEventListener('click', (e) => this.linkEventListener(e));
    });
  }

  /**
   * Popup logic
   * @param {PointerEvent} e 
   */
  async linkEventListener(e) {
    e.preventDefault();
    const title = e.target.textContent;

    // Create wrapper if needed
    let wrapperDiv = document.querySelector('.pop-up-link-wrapper');
    if (wrapperDiv === null) {
      wrapperDiv = document.createElement('div');
      wrapperDiv.classList.add('pop-up-link-wrapper');
      wrapperDiv.innerHTML = this.createBody();
      wrapperDiv.querySelector('.o-button--close').addEventListener('click', () => {
        wrapperDiv.querySelector('.c-filter--pop-up').classList.remove('open');
      });
      document.querySelector('body').appendChild(wrapperDiv);
    }

    // Add loader
    wrapperDiv.querySelector('.c-filter--pop-up--content').innerHTML = this.getSpinner();
    // Add open class after short delay
    // Otherwise the slide animation doesn't play
    setTimeout(() => {
      wrapperDiv.querySelector('.c-filter--pop-up').classList.add('open');
    }, 50);

    // Fetch data
    const href = e.target.getAttribute('href');
    const data = await this.fetchData(href);
    // Set title
    wrapperDiv.querySelector('.c-filter--pop-up--title').textContent = data.title;
    const anchor = (new URLPattern(href, window.location.href)).hash;
    wrapperDiv.querySelector('.c-filter--pop-up--content').innerHTML = data.content;
    // Scroll to anchor
    document.getElementById(anchor).scrollIntoView({ behavior: "smooth" })
  }

  /**
   * Fetches page content
   * @param {string} href 
   * @returns object
   */
  async fetchData(href) {
    return await fetch(href)
      .then(response => response.text())
      .then(function (html) {
        const parser = new DOMParser();
        const responsePage = parser.parseFromString(html, "text/html");
        const content = responsePage.querySelector('#main').innerHTML;
        const pageTitle = responsePage.querySelector('title').textContent.split(' | ')[0];
        return {
          title: pageTitle,
          content: content
        };
      });
  }

  /**
   * Default body for popup
   * @returns string
   */
  createBody() {
    return `
<div class="c-filter--pop-up">
    <div class="c-filter--pop-up--inner">
        <div class="c-filter--pop-up--header bg-secondary">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center py-7">
                            <div class="u-text--25 u-font-weight--500 c-filter--pop-up--title"></div>
                            <div class="o-button--close">
                                <figure>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16.302" height="16.302" viewBox="0 0 16.302 16.302">
                                        <g id="Gruppe_8402" data-name="Gruppe 8402" transform="translate(6837.914 -13771.086)">
                                            <line id="Linie_720" data-name="Linie 720" x2="13.474" y2="13.474" transform="translate(-6836.5 13772.5)" fill="none" stroke-linecap="round" stroke-width="2" />
                                            <line id="Linie_721" data-name="Linie 721" x1="13.474" y2="13.474" transform="translate(-6836.5 13772.5)" fill="none" stroke-linecap="round" stroke-width="2" />
                                        </g>
                                    </svg>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-filter--pop-up--content"></div>
    </div>
</div>`;
  }

  /**
   * Spinner HTML
   * @returns string
   */
  getSpinner() {
    return `
  <div class='d-flex justify-content-center mt-6'>
    <span class='o-loader'></span>
  </div>`;
  }
}
